import { Point } from "highcharts";
import { HighChartsCoverageWidgetTotals } from "./generateHighChartsTotalCostsFromCoverage";
import { generateCoverageChartTooltipMarkup } from "./generateCoverageChartTooltipMarkup";
import { HighChartDataSeriesMapType } from "@/storybook/c8r-highcharts/common/utils/helpers/aggregateHighChartDataSeriesMap";

export const getCoverageWidgetTooltipValueFormatter = (
  chartDataCostBasedMap?: HighChartDataSeriesMapType,
  chartDataPercentBasedMap?: HighChartDataSeriesMapType,
  totalCostsMap?: HighChartsCoverageWidgetTotals,
) => {
  return (point: Point) => {
    const total = totalCostsMap?.get(point.index.toString());

    const costBasedData = chartDataCostBasedMap?.get(point.series.name)?.data;
    const percentBasedData = chartDataPercentBasedMap?.get(
      point.series.name,
    )?.data;

    const value = costBasedData?.[point.index]?.y ?? 0;
    const percent = percentBasedData?.[point.index]?.y ?? 0;

    return generateCoverageChartTooltipMarkup(
      `${point.category}`,
      point.series.name,
      `${point.color}`,
      value,
      percent,
      total?.amount ?? 0,
      total?.percentage ?? 0,
    );
  };
};
